module.exports = __webpack_public_path__ + "img/cross-image.68b716ae.webp";